import { TAppState } from '../../types';
import { ESubscriptionLevel } from '../../types/packages/subscriptionLevel';
import { selectBuyPackageModalData } from '.';

export function selectSubscriptionLevel(state: TAppState): ESubscriptionLevel | undefined {
  const { level } = selectBuyPackageModalData(state);

  return level;
}
